export default __webpack_public_path__ + "static/media/BeVietnam-LightItalic.117d449b.ttf";